import { render } from "./MeetingBox.vue?vue&type=template&id=7fe8e778"
import script from "./MeetingBox.vue?vue&type=script&lang=js"
export * from "./MeetingBox.vue?vue&type=script&lang=js"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__